import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IValidatorMessages } from '../../shared/interfaces';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
})
export class InputComponent implements OnInit {

  @Input() label: string;
  @Input() type: string;
  @Input() name: string;

  @Input() form: FormGroup;
  @Input() messages?: IValidatorMessages;
  @Input() showErrors?: boolean;

  constructor() { }

  ngOnInit() {}

}
